import { encryptPin, hashCommands, Pin, isValidPin } from './construct/pin'
import { crccs } from './crccs'

export type { Pin }

export interface LockUnlockBarcodeOptions {
    readonly shouldLock: boolean | null
    readonly pin?: Pin
}

/**
 * Generate data for a qr code that will lock/unlock scanner
 * @param options configuration options
 * @returns a string suitable for encoding into a QR code
 */
export const checkingShouldLock = (
    shouldLock: boolean | null,
    pin: Pin | undefined
) => {
    let commandAcc = undefined
    if (pin != null && !isValidPin(pin)) throw new Error('Pin is not valid')

    const pinCommand = 'CFLKXLK'
    const unLockCommand = 'CFLKXUK'
    if (shouldLock != null) {
        if (pin == null)
            throw new Error('Pin is required when should lock or unlock')

        const finalCommand = shouldLock ? pinCommand : unLockCommand

        const bytePinReturn = encryptPin(pin)

        commandAcc =
            finalCommand +
            bytePinReturn.substring(0, bytePinReturn.length / 2) +
            hashCommands(finalCommand + bytePinReturn) +
            bytePinReturn.substring(bytePinReturn.length / 2)
    }
    return commandAcc
}
export const lockUnlockBarcode = ({
    shouldLock,
    pin,
}: LockUnlockBarcodeOptions) => {
    const commandAcc = []
    const lockCommand = checkingShouldLock(shouldLock, pin)
    if (lockCommand) commandAcc.push(lockCommand)

    return crccs(commandAcc)
}
